exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row1 {\r\n    height: 540px;\r\n}\r\n\r\n.row2 {\r\n    height:550px;\r\n}\r\n\r\n\r\n.card.clickable:hover {\r\n    box-shadow: 0 0.125rem 0 0 #9A9A9A !important;\r\n    border: 1px solid #9A9A9A !important;\r\n\r\n}\r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n  \r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/emaray.io/src/app/portfolio/portfolio.component.css
// module id = ../../../../../src/app/portfolio/portfolio.component.css
// module chunks = main